
import BackboneEvents from "backbone-events-standalone"

import Config from "./Config"
import Log from "./Log"
import Util from "./Util"


export default class Event
{
    /**
     * [Note]
     *
     * @returns mixed
     */
    static provider()
    {
        if (!this.Provider) {
            this.Provider = BackboneEvents.mixin({});
        }

        return this.Provider;
    }

    /**
     * [Note]
     *
     * @param {String} name
     * @param {Object} params
     * @returns void
     */
    static fire(name, params = {})
    {
        if (Config.get('log.events'))
        {
            let logParams = Util.isObject(params)
                ? {name, ...params}
                : {name, params};

            Log.object(name + ' Event Fired', logParams);
        }

        Event.provider().trigger(name, params);
    }

    /**
     * [Note]
     *
     * @param {String} name
     * @param {Function} callback
     * @returns BackboneEvents
     */
    static listen(name, callback)
    {
        Event.provider().on(name, callback);
    }

    /**
     * [Note]
     *
     * @param {String} name
     * @param {Function} callback
     * @returns void
     */
    static listenOnce(name, callback)
    {
        Event.provider().once(name, callback);
    }
    /**
     * [Note]
     *
     * @param {String} name
     * @param {Function} callback
     * @param {Component} component
     * @returns void
     */
    static ignore(name, callback, component)
    {
        Event.provider().off(name, callback, component);
    }


    /**
     * [Note]
     *
     * @param {Component} component
     * @returns void
     */
    static bindComponent(component)
    {
        let events = this.componentEvents(
            component
        );

        for (let key in events)
        {
            this.listen(
                key, Event.componentCallback(
                    events[key], component
                )
            );
        }
    }

    /**
     * [Note]
     *
     * @param {Component} component
     * @returns void
     */
    static unbindComponent(component)
    {
        let events = this.componentEvents(
            component
        );

        for (let key in events)
        {
            this.ignore(
                key, Event.componentCallback(
                    events[key], component
                ), component
            );
        }
    }

    /**
     * [Note]
     *
     * @param {Component} component
     * @returns {Object}
     */
    static componentEvents(component)
    {
        if (!component.constructor.events) {
            return {};
        }

        let events = component.constructor.events;
        if (Util.isFunction(events)) {
            events = component.constructor.events();
        }

        return events;
    }

    /**
     * [Note]
     *
     * @param {String} event
     * @param {Component} component
     * @returns void
     */
    static componentCallback(event, component)
    {
        return (...params) => {
            if (!component._isMounted) {
                return;
            }

            event(component, ...params);
        }
    }
}
